import { Container, Title, Text } from "@mantine/core";
import classes from "./dashboard.module.css";

export function Dashboard() {
  return (
    <div className={classes.root}>
      <Container size="lg">
        <div className={classes.inner}>
          <div className={classes.content}>
            <Title className={classes.title}>
              A{" "}
              <Text
                component="span"
                inherit
                variant="gradient"
                gradient={{ from: "pink", to: "yellow" }}
              >
                fully featured
              </Text>{" "}
               The Greek Wedding Show Admin Panel
            </Title>
          </div>
        </div>
      </Container>
    </div>
  );
}
